@if (splashScreenVisible()) {
<div class="splash-screen-container" animate.leave="splash-screen-leave">
  <app-splash-screen />
</div>
}

<div class="app-container" [class.app-container--cabinet-shell]="cabinetShellActive()">
  <main
    class="app-content"
    [class.app-content--cabinet-shell]="cabinetShellActive()"
  >
    <router-outlet />
  </main>
</div>

<div class="system-notification-container">
  <lib-not-system-notification />
</div>
